<template>
  <div>
    <header-component></header-component>

    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header">
          <h3 class="mb-0" style="text-transform:capitalize;">Statuses List</h3>
          <div class="col-lg-12 col-5 text-right">
            <base-button size="sm" type="primary" @click="createStatus">Add New</base-button>
          </div>
        </div>
        <el-table
          class="table-responsive table-flush"
          header-row-class-name="thead-light"
          :data="statusList"
        >
          <el-table-column label="Name" prop="label"></el-table-column>
          <el-table-column label="Code" prop="code"></el-table-column>
          <el-table-column min-width="70px">
            <template slot-scope="scope">
              <el-dropdown slot="dropdown" @command="command => handleAction(scope.row, command)">
                 <el-button type="primary" size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                  <el-dropdown-item command="edit">Edit</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog title="Add Status" :visible.sync="addStatus">
        <add-status @close="addStatus = false"></add-status>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button
} from "element-ui";
import { mapGetters, mapActions, mapMutations } from "vuex";
import AddStatus from "./AddStatus";
import headerComponent from "../Components/HeaderComponent";

export default {
  data: () => {
    return {
      addStatus: false
    };
  },

  computed: {
    ...mapGetters({
      statusList: "status/getStatusList",
      status: "status/getStatus"
    })
  },
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    "add-status": AddStatus,
    "header-component": headerComponent
  },
  mounted() {
    this.getStatusList();
  },
  methods: {
    ...mapActions({
      getStatusList: "status/getStatusList",
      fetchStatus: "status/fetchStatus"
    }),
    ...mapMutations({
      setStatus: "status/setStatus",
      resetStatus: "status/resetStatus"
    }),

    handleAction(status, command) {
      if (command === "edit") {
        this.fetchStatus(status.statusId).then(res => {
          this.addStatus = true;
          this.setStatus(res);
        });
      }
    },

    createStatus() {
      this.resetStatus();
      this.addStatus = true;
    }
  }
};
</script>